'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = auth;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    loadedInServer: false,
    loaded: null,
    loading: false,
    loggingIn: false,
    user: null
};

function auth() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.AuthConstants.AUTH_LOAD:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case _constants.AuthConstants.AUTH_LOAD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                loading: false,
                loaded: true,
                user: action.result
            });
        case _constants.AuthConstants.AUTH_LOAD_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false,
                loaded: false,
                error: action.error
            });
        case _constants.AuthConstants.AUTH_LOAD_IN_SERVER:
            return (0, _extends3.default)({}, state, {
                loadedInServer: true
            });
        case _constants.AuthConstants.LOGIN:
            return (0, _extends3.default)({}, state, {
                preload: true,
                loggingIn: true,
                loginError: null
            });
        case _constants.AuthConstants.LOGIN_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                loggingIn: false,
                user: action.result,
                loginError: null
            });
        case _constants.AuthConstants.ONE_CLICK_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false
            });
        case _constants.AuthConstants.ONE_CLICK_CONFIRM_ERROR:
            return (0, _extends3.default)({}, state, {
                preload: false,
                loggingIn: false,
                user: null,
                loginError: action.error.title,
                loginErrorCode: action.error.title
            });
        case _constants.AuthConstants.LOGIN_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                loggingIn: false,
                user: null,
                loginError: action.error.title,
                loginErrorCode: action.error.title
            });
        case _constants.AuthConstants.LOGOUT:
            return (0, _extends3.default)({}, state, {
                loggingOut: true
            });
        case _constants.AuthConstants.LOGOUT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                loggingOut: false,
                user: null
            });
        case _constants.AuthConstants.REFRESH_LOGOUT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                loggingOut: false,
                user: null
            });
        case _constants.AuthConstants.LOGOUT_FAIL:
            return (0, _extends3.default)({}, state, {
                loggingOut: false,
                logoutError: action.error.title
            });
        case _constants.AuthConstants.AUTH_RESET_ERROR:
            return (0, _extends3.default)({}, state, {
                logoutError: null,
                loginError: null,
                loginErrorCode: null
            });

        case _constants.AuthConstants.AUTH_RESET:
            return (0, _extends3.default)({}, state, {
                loaded: null,
                user: null,
                loadedInServer: false
            });

        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/auth.js
// module id = 1895
// module chunks = 0